"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Time = void 0;

var _TimeRange = require("./TimeRange.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Time = /*#__PURE__*/function () {
  /**
   * create a new Time object with milliseconds and epoch in UTC milliseconds
   *
   * @constructor
   * @param {number} localTimeVal - milliseconds in local time
   * @param {number} [epoch=0] - epoch in UTC milliseconds
   * @return {Time}
   * @memberof Time
   */
  function Time(localTimeVal, epoch) {
    _classCallCheck(this, Time);

    this._epoch = epoch;
    this._utc = localTimeVal + epoch;
  }
  /**
   * set value of Time object with local time in seconds
   *
   * @param {number} localTime - seconds in local time
   * @memberof Time
   */


  _createClass(Time, [{
    key: "setSeconds",
    value: function setSeconds(localTime) {
      this._utc = localTime * 1000 + this._epoch;
    }
    /**
     * set value of Time object with local time in milliseconds
     *
     * @param {number} milliseconds - milliseconds in local time
     * @memberof Time
     */

  }, {
    key: "setMilliseconds",
    value: function setMilliseconds(localTime) {
      this._utc = localTime + this._epoch;
    }
    /**
     * return milliseconds UTC value of this Time object
     *
     * @readonly
     * @memberof Time
     */

  }, {
    key: "utc",
    get: function get() {
      return this._utc;
    }
    /**
     * return seconds UTC value of this Time object
     *
     * @readonly
     * @memberof Time
     */

  }, {
    key: "utcSeconds",
    get: function get() {
      return this._utc / 1000;
    }
    /**
     * convert this Time object to a new Time object with supplied epoch
     *
     * @param {number} epoch - epoch in UTC milliseconds
     * @memberof Time
     */

  }, {
    key: "timeWithEpoch",
    value: function timeWithEpoch(epoch) {
      var localTime = this._utc - epoch;
      return new Time(localTime, epoch);
    }
    /**
     * add milliseconds to this Time object
     * @param {number} milliseconds - milliseconds to add
     * @memberof Time
     */

  }, {
    key: "addMilliseconds",
    value: function addMilliseconds(milliseconds) {
      this._utc += milliseconds;
    }
    /**
     * add seconds to this Time object
     * @param {number} seconds - seconds to add
     * @memberof Time
     */

  }, {
    key: "addSeconds",
    value: function addSeconds(seconds) {
      this._utc += seconds * 1000;
    }
    /**
     * subtract milliseconds from this Time object
     * @param {number} milliseconds - milliseconds to subtract
     * @memberof Time
     */

  }, {
    key: "subtractMilliseconds",
    value: function subtractMilliseconds(milliseconds) {
      this._utc -= milliseconds;
    }
    /**
     * subtract seconds from this Time object
     * @param {number} seconds - seconds to subtract
     * @memberof Time
     */

  }, {
    key: "subtractSeconds",
    value: function subtractSeconds(seconds) {
      this._utc -= seconds * 1000;
    }
    /**
     * find how long ago in the past that passed time is from this Time object
     * to(firsttime) ... this(secondtime)
     * @param {number|Time} to - time or utc milliseconds to calculate from
     * @return {TimeRange} - milliseconds ago
     * @memberof TimeRange
     */

  }, {
    key: "timeAgo",
    value: function timeAgo(to) {
      var toTime = null;

      if (to instanceof Time) {
        toTime = to;
      } else {
        toTime = Time.fromMilliseconds(to);
      }

      return _TimeRange.TimeRange.from(to, this);
    }
    /**
     * find how much in the future the passed time is from this Time object
     * this(firsttime) ... to(secondtime)
     * @param {number|Time} to - time or utc milliseconds to calculate from
     * @return {TimeRange} - milliseconds ago
     * @memberof TimeRange
     */

  }, {
    key: "timeUntil",
    value: function timeUntil(to) {
      var toTime = null;

      if (to instanceof Time) {
        toTime = to;
      } else {
        toTime = Time.fromMilliseconds(to);
      }

      return _TimeRange.TimeRange.from(this, to);
    }
  }], [{
    key: "fromSeconds",
    value:
    /**
     * create a new Time object with seconds and epoch in UTC milliseconds
     *
     * @static
     * @param {number} seconds - seconds in local time
     * @param {number} [epoch=0] - epoch in UTC milliseconds
     * @return {Time}
     * @memberof Time
     */
    function fromSeconds(seconds) {
      var epoch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return new Time(seconds * 1000, epoch);
    }
    /**
     * create a new Time object with milliseconds and epoch in UTC milliseconds
     *
     * @static
     * @param {number} milliseconds - milliseconds in local time
     * @param {number} [epoch=0] - epoch in UTC milliseconds
     * @return {Time}
     * @memberof Time
     */

  }, {
    key: "fromMilliseconds",
    value: function fromMilliseconds(milliseconds) {
      var epoch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return new Time(milliseconds, epoch);
    }
    /**
     * create a new Time object based on moment start time
     *
     * @static
     * @param {Moment} moment - graphql shaped moment
     * @return {Time}
     * @memberof Time
     */

  }, {
    key: "fromMoment",
    value: function fromMoment(moment) {
      var _moment$start_time;

      return new Time((_moment$start_time = moment === null || moment === void 0 ? void 0 : moment.start_time) !== null && _moment$start_time !== void 0 ? _moment$start_time : 0, 0);
    }
  }]);

  return Time;
}();

exports.Time = Time;